<section class="topimg about-header">
  <div class="container">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-sm-12 col-12 d-flex align-items-center justify-content-center"
        data-aos="fade-up" data-aos-duration="2000">
        <div>
          <h3 class="title-text">Careers</h3>
          <p class="title-text1">
            Join us in this exciting journey in making ComUnus a dream company to work with and also creating customer
            delight by adding immense value to the business.
          </p>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-sm-12 col-12 d-flex align-items-center justify-content-center"
        data-aos="fade-up" data-aos-duration="2000">
        <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/Q0aCbtzb_EM?si=mlxiKvB_tsjzc3Un&loop=1&autoplay=1&showinfo=0" frameborder="0" allowfullscreen>
        </iframe>     -->
        <div class="header-img"></div>
      </div>
    </div>
  </div>
</section>
<section class="Content">
  <div class="container">
    <div class="row">
      <div class="col-md-12 pt-3 pt-5">
        <h3 class="title-text">Why ComUnus</h3>
        <p class="title-text1">
          At ComUnus Technologies Pvt Ltd, you will get to experience an environment that has the latest technology,
          colleagues with diverse views, a high risk-reward culture. Many people find this culture to be highly
          interesting, extremely learning oriented and fun too!
        </p>
        <p class="title-text1">
          As one of the fastest growing organization,ComUnus believe in delivering tangible results to our customers in
          a cost-effective manner.You'll find a positive and passionate work culture.
        </p>
        <p class="title-text1">ComUnus welcome you to be a part of our journey....!!!! </p>
      </div>


      <!-- <div class="col-md-12">
        <div class="btn-toggle">
          <div class="toggle-container">
            <button class="toggle-btn" [class.active]="selected === 'resume'" (click)="selected = 'resume'">
              Post Your Resume
            </button>

            <button class="toggle-btn" [class.active]="selected === 'openings'" (click)="selected = 'openings'">
              Current Openings
            </button>
          </div>
        </div>
      </div> -->


      <!-- <div class="col-md-12 post-resume-content" id="postyouresume" *ngIf="selected === 'resume'">
        <h4 class="title-text pt-2"> Post Your Resume</h4>
        <p>Upload your resume and take the next step toward your dream career.</p>
        <form [formGroup]="careerForm" class="career-form" autocomplete="new-password">
          <div class="form-grid row">
            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>First Name <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="firstName" placeholder="Enter First Name">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Last Name <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="lastName" placeholder="Enter Last Name">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Email ID <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="email" formControlName="email" placeholder="Enter Email">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Mobile No <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="number" formControlName="mobile" placeholder="Enter Mobile No">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Location <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="location" placeholder="Enter Location">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Experience <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="experience" placeholder="Enter Experience">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <div class="d-flex justify-content-between"> <mat-label>Skills <span>*</span> </mat-label>
                  <mat-hint>Only 5 skills are allowed</mat-hint></div>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="skills" placeholder="Enter Skills">

                </mat-form-field>


              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Qualification <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="qualification" placeholder="Enter Qualification">

                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Notice Period (in days) <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="number" formControlName="noticePeriod" placeholder="Enter Notice Period"
                    oninput="if(this.value.length > 2) this.value = this.value.slice(0,2)">

                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Current CTC <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input type="number" matInput formControlName="currentCtc" placeholder="Enter Current CTC">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label>Expected CTC <span>*</span> </mat-label>
                <mat-form-field appearance="outline">
                  <input type="number" matInput formControlName="expectedCtc" placeholder="Enter Expected CTC">
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 col-12">
              <div class="formGroup">
                <mat-label> Upload your Resume <span>*</span> </mat-label>
                <div class="upload-file">
                  <input type="file" (change)="onFileChange($event)" accept=".pdf,.doc,.docx">
                </div>
              </div>
            </div>
          </div>

          <button color="primary" type="submit" class="submit-btn"> Submit </button>
        </form>
      </div> -->
    </div>

    <!-- <div class="currentOpening" id="currentOpening" *ngIf="selected === 'openings'"> -->
      <div class="row">
        <div class="col-md-12 pt-3">
          <h4 class="title-text">Current Openings</h4>
          <p class="title-text1">
            ComUnus Technologies Pvt. Ltd. offers great career opportunities across the globe.
          </p>
          <p class="title-text1 pb-4">
            Join us in this exciting journey in making ComUnus a dream company to work with and also creating customer
            delight by adding immense value to the business.
          </p>
        </div>
      </div>
      <!-- <button class="common-career-footer-card-btn"> <a href="http://13.235.81.101/online_candidate_form" target="_blank"> Apply Now <mat-icon>arrow_right_alt</mat-icon></a></button> -->
      <!-- <div class="col-md-12 mt-4">
        <mat-accordion>
          <div *ngFor="let jd of jds">
            <mat-expansion-panel class="panel" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>-->
      <!-- <img src="../../assets/img/java.png"> -->
      <!-- <div class="head">
                    {{jd.jobHeading}}
                    <p> {{jd.jobDescription}} </p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header><br>
              <h4 class="heading">{{jd.jobDescription}} </h4>
              <div class="desc">
                <ul>
                  <li *ngFor="let val of jd.jdList; let index = index">
                    {{ val }}.
                  </li>
                </ul>
              </div> -->
      <!-- <button class="common-career-footer-card-btn"><a href="mailto:heramb.limaye@comunus.in" target="_blank"> Apply Now <mat-icon>arrow_right_alt</mat-icon></a></button> -->
      <!-- <a [href]="jd.applyUrl" class="common-career-footer-card-btn btn" target="_blank"> Apply Now</a>

            </mat-expansion-panel>
          </div>
        </mat-accordion>
      </div> -->
      <div class="row"  >
        <div class="col-xl-6 col-lg-4 col-md-6" *ngFor="let jd of jds">
          <div class="listbox">
            <div class="d-flex justify-content-between">
              <div class="company-details">
                <h4>{{jd.jobHeading}}</h4>
                <p>{{jd.companyName}}</p>
              </div>

              <div class="company-logo">
                <img src="assets/img/comunus.jpg">
              </div>
            </div>
            <div class="list-price">
              <ul>
                <li>
                  <img src="assets/img/year.svg">
                  {{jd.fromYearExp}}-{{jd.toYearExp}} Yrs
                </li>

                <li *ngIf="jd.salaryRange">
                  <img src="assets/img/inr.svg">
                  {{jd.salaryRange}}
                </li>

                <li *ngIf="jd.location">
                  <span class="location" title="{{jd.location}}">
                    <img src="assets/img/map.svg">
                    {{jd.location}}
                  </span>
                </li>
              </ul>
            </div>

            <p>
              <img src="assets/img/txt-details.svg">
              {{jd.jobDescription}}
            </p>

            <div class="daytxt">
              <div class="applyNow">
                <a [href]="jd.applyUrl" class="common-career-btn" target="_blank">
                  Apply Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- No Jobs Found 

      <ng-template #noJobs>
        <div class="text-center mt-5 mb-5 no-job-box">
          <img src="assets/img/no-jobs-vailable.svg">
        </div>
      </ng-template> 
     
    </div>-->

    <div class="col-12 pl-0">
      <h6 class="title-text1 mt-2">
        Note : If you are facing any issue in applying online, you can also mail your details with Updated Resume,
        Current CTC, Expected CTC, Notice Period with Job Code mentioned in Subject Line to
        <a href="mailto:career@comunus.in" target="_blank">careers@comunus.in</a>
      </h6>
    </div>


  </div>
</section>